/* cart-bubble-sync.js | Keep navbar cart bubble in sync without re-rendering the button */
(function () {
  if (window.CartBubbleSyncLoaded) return;
  window.CartBubbleSyncLoaded = true;

  /* ---------- helpers ---------- */
  function setCartBubble(count) {
    const btn = document.getElementById('cart-icon-bubble');
    if (!btn) return;

    let bubble = btn.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        btn.appendChild(bubble);
      }
      bubble.firstElementChild.textContent = count;
      bubble.lastElementChild.textContent = `${count} items`;
    } else if (bubble) {
      bubble.remove();
    }
  }

  /* ---------- generic patch utilities ---------- */
  function filterIconBubble(tagName) {
    customElements.whenDefined(tagName).then(() => {
      const ctor = customElements.get(tagName);
      if (!ctor || !ctor.prototype) return;
      const proto = ctor.prototype;
      if (proto.__bubbleFilterApplied) return;
      proto.__bubbleFilterApplied = true;
      if (typeof proto.getSectionsToRender !== 'function') return;
      const original = proto.getSectionsToRender;
      proto.getSectionsToRender = function () {
        const list = original.call(this) || [];
        return list.filter((s) => s && s.id !== 'cart-icon-bubble');
      };
    });
  }

  function patchRenderContents(tagName) {
    customElements.whenDefined(tagName).then(() => {
      const ctor = customElements.get(tagName);
      if (!ctor || !ctor.prototype) return;
      const proto = ctor.prototype;
      if (proto.__bubbleRenderPatched) return;
      proto.__bubbleRenderPatched = true;
      if (typeof proto.renderContents !== 'function') return;
      const original = proto.renderContents;
      proto.renderContents = function (parsedState) {
        if (parsedState && typeof parsedState.item_count === 'number') {
          setCartBubble(parsedState.item_count);
        }
        return original.apply(this, arguments);
      };
    });
  }

  ['cart-items', 'cart-drawer', 'cart-notification'].forEach((tag) => {
    filterIconBubble(tag);
    patchRenderContents(tag);
  });

  /* --------- intercept fetch to /cart/add.js to update bubble instantly --------- */
  const originalFetch = window.fetch;
  window.fetch = function(input, init){
    const url = (typeof input === 'string') ? input : input.url;
    if(url && url.includes('/cart/add.js')){
      return originalFetch(input, init).then((res)=>{
        try{
          res.clone().json().then((data)=>{
            if(data && typeof data.item_count === 'number') setCartBubble(data.item_count);
          });
        }catch(e){}
        return res;
      });
    }
    return originalFetch(input, init);
  };

  /* Initial sync on DOM ready using Shopify cart object if present */
  const syncInitial = () => {
    if (window.__st && typeof window.__st.items === 'number') {
      setCartBubble(window.__st.items);
    } else if (window.Shopify && Shopify.cart && typeof Shopify.cart.item_count === 'number') {
      setCartBubble(Shopify.cart.item_count);
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncInitial);
  } else {
    syncInitial();
  }
  /* ---------- EA Sticky Cart integration ---------- */
  function observeEACart() {
    const target = document.querySelector('.ea-sticky-cart .easc-cartCountDiv p');
    if (!target) return;
    const applyCount = () => {
      const val = parseInt(target.textContent.trim(), 10);
      if (!isNaN(val)) setCartBubble(val);
    };
    // initial
    applyCount();
    const obs = new MutationObserver(applyCount);
    obs.observe(target, { characterData: true, childList: true, subtree: true });
  }

  if (window.Shopify && window.Shopify.theme && window.Shopify.theme.settings && window.Shopify.theme.settings.disable_native_cart_drawer === true) {
    // Delay a bit because EA injects its DOM after load
    setTimeout(observeEACart, 1500);
  }

  /* ---------- Icon SVG Guard ---------- */
  function guardIconSvg() {
    const btn = document.getElementById('cart-icon-bubble');
    if (!btn) return;
    const svgEl = btn.querySelector('svg');
    if (!svgEl) return;
    svgEl.setAttribute('data-original-cart-icon','');
    const pristine = svgEl.outerHTML;
    const observer = new MutationObserver(() => {
      // Elimina cualquier wrapper extra que Dawn/EA añada
      const unwantedWrapper = btn.querySelector('.svg-wrapper');
      if (unwantedWrapper && !unwantedWrapper.querySelector('svg[aria-hidden]')) {
        unwantedWrapper.remove();
      }

      const hasPristine = btn.querySelector('svg[data-original-cart-icon]');
      if (!hasPristine) {
        btn.insertAdjacentHTML('afterbegin', pristine);
      }
    });
    observer.observe(btn, { childList: true, subtree: true, attributes: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guardIconSvg);
  } else {
    guardIconSvg();
  }

  /* Listen to custom event external:cart:add to sync bubble */
  window.addEventListener('external:cart:add', () => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        if (data && typeof data.item_count === 'number') setCartBubble(data.item_count);
      });
  });
})();